import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import theme from './src/theme/theme';
import AppRouter from './src/components/AppRouter';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorFallback from './src/components/common/ErrorFallback';

const App: React.FC = () => {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <ThemeProvider theme={theme}>
        <AppRouter />
      </ThemeProvider>
    </ErrorBoundary>
  );
};

export default App;
